module.exports = __webpack_public_path__ + "static/media/logo-mod.814d5774.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/clientlogos/logo-mod.png
// module id = 559
// module chunks = 0